var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 55 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_290_528)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7149 32.9982V17.7913C43.7149 16.6524 43.1074 15.6001 42.1208 15.0305L28.9515 7.42719C27.9653 6.8576 26.75 6.8576 25.7637 7.42719L12.5938 15.0305C11.6075 15.6001 11 16.6524 11 17.7913V32.9982C11 34.1371 11.6075 35.1898 12.5938 35.7591L25.7637 43.3624C26.75 43.9319 27.9653 43.9319 28.9515 43.3624L42.1208 35.7591C43.1074 35.1898 43.7149 34.1371 43.7149 32.9982Z",
    fill: "#4F46E5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.234 25.344C19.234 25.344 19.2634 27.5586 19.322 31.988C19.322 32.296 19.234 32.5673 19.058 32.802C18.8967 33.022 18.662 33.132 18.354 33.132C18.046 33.132 17.7967 33.022 17.606 32.802C17.4154 32.5673 17.32 32.296 17.32 31.988L17.43 25.344L17.32 18.854C17.32 18.546 17.4154 18.2746 17.606 18.04C17.7967 17.8053 18.046 17.688 18.354 17.688C18.662 17.688 18.8967 17.8053 19.058 18.04C19.234 18.26 19.322 18.568 19.322 18.964C19.322 19.36 19.3074 20.1373 19.278 21.296C19.2634 22.44 19.256 23.1586 19.256 23.452C20.0774 22.0733 21.236 20.768 22.732 19.536C24.2427 18.304 25.4454 17.688 26.34 17.688C26.6774 17.688 26.956 17.7906 27.176 17.996C27.4107 18.2013 27.528 18.4653 27.528 18.788C27.528 19.1106 27.4107 19.3746 27.176 19.58C26.956 19.7853 26.7287 19.888 26.494 19.888C26.2594 19.888 26.0174 19.8293 25.768 19.712C25.5334 19.58 25.2694 19.514 24.976 19.514C24.6827 19.514 24.2354 19.734 23.634 20.174C23.0327 20.614 22.3874 21.2006 21.698 21.934C21.038 22.6673 20.5027 23.3566 20.092 24.002C24.4774 29.6926 29.7794 33.9973 35.998 36.916C36.9514 37.356 37.428 37.8546 37.428 38.412C37.428 38.7053 37.3254 38.94 37.12 39.116C36.9147 39.292 36.6287 39.38 36.262 39.38C35.3527 39.38 33.8274 38.6173 31.686 37.092C29.5594 35.5666 27.352 33.7406 25.064 31.614C24.0227 30.6606 22.9447 29.5826 21.83 28.38C20.73 27.1626 19.8647 26.1506 19.234 25.344Z",
    fill: "#F7F8FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_290_528",
    x: 0,
    y: 0,
    width: 54.7149,
    height: 58.7896,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.736838 0 0 0 0 0.781525 0 0 0 0 0.925611 0 0 0 0.321651 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_290_528"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_290_528",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.0e850498535136e0e08f8db0db3186eb.svg";
export { ForwardRef as ReactComponent };